/*
 * @Description:
 * @Author: yuxin
 * @Date: 2024-01-10 11:57:31
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-06-18 10:50:42
 * @FilePath: \mgr_web\src\domainNameConfig.js
 */
// 动态域名配置  自动返回当前环境下域名 失败返回空
/** 这里当提示的时候,检查一下 */
// 一、生产环境  1.测试、2.正式
let domainName = "";
console.log('测试域名------',process,process.env);
// if (process.env.NODE_ENV === "production") {
  // 打包构建后
  domainName=process.env.VUE_APP_DOMAIN_URL+'/klb-service'
  // if (location.hostname && location.hostname == "mgr-callback.test.hmsaas.cn") {
  //   domainName = "https://mgr-callback.test.hmsaas.cn/klb-service";
  // } else if (
  //   location.hostname &&
  //   location.hostname == "wecom.test.hmcsoft.net"
  // ) {
  //   domainName = "http://wecom.test.hmcsoft.net:8016";
  // } else if (
  //   location.hostname &&
  //   location.hostname == "wecom-callback.dev.hmsaas.cn"
  // ) {
  //   console.log("会不会进来");
  //   domainName = "https://wecom-callback.dev.hmsaas.cn";
  // } else {
  //   // 3..正式
  //   /** 旧的会话存档打包 */
  //   // domainName = "http://wx.hmcsoft.com:8016";
  //   /** 新版会话存档打包 */
  //   // domainName = "https://klb.hmsaas.cn";
  //   // domainName = "https://wecom.hmsaas.cn/klb-service"; //生产
  //   // domainName = "http://wecom-pre.hmsaas.cn/klb-service"; //预发布
  //   // domainName = "https://mgr-callback.test.hmsaas.cn/klb-service"; //测试
  //   domainName = "https://wecom-callback.dev.hmsaas.cn/klb-service";
  // }
// } else {
  // 本地开发

  /** 流水线打包打开这个 */
  // domainName = "https://mgr2-callback.test.hmsaas.cn/klb-service";
  // domainName = "https://mgr-callback.test.hmsaas.cn/klb-service";
  // domainName = "https://wecom-callback.dev.hmsaas.cn/klb-service";
  // domainName = "https://wecom.hmsaas.cn/klb-service"; //生产
  // domainName = "http://wecom-pre.hmsaas.cn/klb-service"; //预发布
// }
// else  {
//   /** 流水线打包打开这个 */
//     domainName = "https://mgr-callback.test.hmsaas.cn/klb-service";
//   /** 本地打包 */
//   // domainName = "/adminApi";
// }

export default domainName;
